import PropTypes from 'prop-types';
import React, { useEffect } from 'react'
import Tippy from '@tippyjs/react';
import { ToastContainer } from 'react-toastify';
import PipelineEventsSlidingPaneApp from '../../PipelineEventsSlidingPane/startup/PipelineEventsSlidingPaneApp';

const ActivityFeed = ({
    csrfToken,
    pipelineEvents,
    currentUser,
    pipelineEventsChanged,
    team,
    artist,
    unseenPipelineEvents,
    fetchPipelineEventsForArtist,
    fetchPipelineEventsForArtistOnInit,
    pipelineEventsLoading
})=>{

    useEffect(() => {
      if(fetchPipelineEventsForArtistOnInit){
        fetchPipelineEventsForArtist(team, artist);
      }
    }, [])

    return(
      <>
        <div className="d-inline-block mr-1" title="Activity Feed" style={{"position": "relative"}}>
          {unseenPipelineEvents.length > 0 ? (
            <div className={"btn-alert-count small d-flex justify-content-center " + (unseenPipelineEvents.length < 10 ? "single" : "multi")}>
              <div className="align-self-center">
                {unseenPipelineEvents.length.toLocaleString()}
              </div>
            </div>
          ) : null}
          <a
            href="#"
            onClick={
              (e) => {
                e.preventDefault();
                fetchPipelineEventsForArtist(team, artist);
              }
            }
            className="btn btn-muted-inverse"
            disabled={pipelineEventsLoading}
          >
            {pipelineEventsLoading ? (
              <img src="/uploading-loading.gif"
                   style={{width: "16px"}} />
            ) : (
              <i className="far fa-stream"></i>
            )}
          </a>
        </div>
        <PipelineEventsSlidingPaneApp
          currentUser={currentUser}
          csrfToken={csrfToken}
          artist={artist}
          pipelineEvents={pipelineEvents}
          onClose={
            () => {
              pipelineEventsChanged([]);
            }
          }
          team={team}
        />
      </>
    )
}

ActivityFeed.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  pipelineEvents: PropTypes.array,
  currentUser: PropTypes.object.isRequired,
  pipelineEventsChanged: PropTypes.func.isRequired,
  team: PropTypes.object.isRequired,
  artist: PropTypes.object.isRequired,
  unseenPipelineEvents: PropTypes.array,
  fetchPipelineEventsForArtist: PropTypes.func.isRequired,
  fetchPipelineEventsForArtistOnInit: PropTypes.bool,
  pipelineEventsLoading: PropTypes.bool,
};

export default ActivityFeed
